<script setup lang="ts">
import { ref } from 'vue';
import { NxButton } from '../Button';
import DropdownArea from './DropdownArea.vue';

const emit = defineEmits<{ 'add-table': [width: number, height: number]; close: [] }>();
const width = ref<number>(0);
const height = ref<number>(0);

const SIZE = 10;
const range = [...Array(SIZE * SIZE).keys()];
</script>

<template>
  <DropdownArea
    @close="
      () => {
        width = 0;
        height = 0;
        emit('close');
      }
    "
  >
    <template #default>
      <slot></slot>
    </template>
    <template #area="{ close }">
      <div class="area">
        <div class="grid">
          <NxButton
            v-for="value in range"
            variant="ghost"
            :aria-label="`${Math.floor(value / SIZE) + 1} × ${(value % SIZE) + 1}`"
            :key="value"
            :class="[
              'box',
              { filled: width >= (value % SIZE) + 1 && height >= Math.floor(value / SIZE) + 1 },
            ]"
            @mouseenter="
              () => {
                width = (value % SIZE) + 1;
                height = Math.floor(value / SIZE) + 1;
              }
            "
            @click="
              () => {
                emit('add-table', (value % SIZE) + 1, Math.floor(value / SIZE) + 1);
                close();
              }
            "
          />
        </div>
        <div>{{ `${height} x ${width}` }}</div>
      </div>
    </template>
  </DropdownArea>
</template>

<style scoped>
.area {
  font-size: var(--nxt-font-size-xs);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--nxt-space-xs);
}
.grid {
  display: grid;
  grid-template-columns: repeat(10, 1.25em);
  grid-template-rows: repeat(10, 1.25em);
  gap: 0.125em;
}
.box {
  width: 100%;
  height: 100%;
  min-width: 0;
  padding: 0;
  border-radius: var(--nxt-radius-sm);
  border: solid var(--nxt-hairline) var(--nxt-border);
  &.filled {
    border: solid var(--nxt-hairline) var(--nxt-brand-bg);
    background-color: var(--nxt-brand-bg);
  }
}
</style>
